import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "57810e59-e58b-4fbb-aac8-0cb56c2e8e40", content: "Diaphragm mass", options: {} },
  { id: "0d86ea68-7744-485f-ae08-936fc09bfaf2", content: "Mechanical resistance", options: {} },
  { id: "b0e94d3b-c8d5-406c-bc73-f883fc5acf3a", content: "Diaphragm stiffness", options: {} },
  { id: "310782a2-d6e8-4d22-a55d-db29244fcc5e", content: "Electrical resistance", options: {} },
  { id: "95fcb572-c18c-4d00-b229-085c7e06553c", content: "Diaphragm surface", options: {} },
  { id: "f6be3490-422b-4f69-ab4c-032bfd19f8d3", content: "Inductance", options: {} },
  { id: "9cae5a8e-a2cb-44f2-ab86-4feda17e9d67", content: "Bℓ", options: {} },
  { id: "4cb4ffdb-4d0f-4b31-9f6b-8928e5927dc8", content: "Rear cavity", options: {} },
];

export const task: Task = {
  id: "b349dc42-837b-48a1-aa56-c18956e3e446",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "0d86ea68-7744-485f-ae08-936fc09bfaf2",
    "95fcb572-c18c-4d00-b229-085c7e06553c",
    "9cae5a8e-a2cb-44f2-ab86-4feda17e9d67",
  ],
};
